/* ============================================================
   EZ FILLER — CUSTOM JAVASCRIPT
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     HEADER — scroll effect & mobile nav
  ---------------------------------------------------------- */
  function initHeader() {
    const header = document.querySelector('.ez-header');
    const toggle = document.querySelector('.ez-mobile-toggle');
    const mobileNav = document.querySelector('.ez-mobile-nav');
    if (!header) return;

    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });

    if (toggle && mobileNav) {
      toggle.addEventListener('click', () => {
        const open = toggle.classList.toggle('open');
        mobileNav.classList.toggle('open', open);
        document.body.style.overflow = open ? 'hidden' : '';
      });

      // close on link click
      mobileNav.querySelectorAll('a').forEach(a => {
        a.addEventListener('click', () => {
          toggle.classList.remove('open');
          mobileNav.classList.remove('open');
          document.body.style.overflow = '';
        });
      });
    }

    // Active nav link highlight
    const links = document.querySelectorAll('.ez-nav-link, .ez-mobile-nav a');
    links.forEach(link => {
      if (link.href === window.location.href) link.classList.add('active');
    });
  }

  /* ----------------------------------------------------------
     CONFETTI CANVAS — hero section
  ---------------------------------------------------------- */
  function initConfetti() {
    const canvas = document.getElementById('ez-confetti-canvas');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    function resize() {
      canvas.width  = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    }
    resize();
    window.addEventListener('resize', resize, { passive: true });

    const COLORS = ['#CC0000','#FF4444','#FF8080','#FFFFFF','#FFD700','#FF6B6B'];
    const pieces = Array.from({ length: 80 }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height - canvas.height,
      r: Math.random() * 6 + 3,
      d: Math.random() * 80 + 20,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      tilt: Math.random() * 10 - 10,
      tiltAngle: 0,
      tiltAngleIncrement: (Math.random() * 0.07) + 0.05,
      opacity: Math.random() * 0.6 + 0.3,
    }));

    let angle = 0;
    let raf;

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      angle += 0.008;
      pieces.forEach((p, i) => {
        p.tiltAngle += p.tiltAngleIncrement;
        p.y += (Math.cos(angle + p.d) + 1.5) * 0.8;
        p.x += Math.sin(angle) * 0.6;
        p.tilt = Math.sin(p.tiltAngle - i / 3) * 15;

        ctx.save();
        ctx.globalAlpha = p.opacity;
        ctx.fillStyle = p.color;
        ctx.beginPath();
        ctx.ellipse(p.x + p.tilt, p.y, p.r, p.r / 2, p.tiltAngle, 0, 2 * Math.PI);
        ctx.fill();
        ctx.restore();

        if (p.y > canvas.height + 20) {
          p.y = -10;
          p.x = Math.random() * canvas.width;
        }
      });
      raf = requestAnimationFrame(draw);
    }

    // Only run when hero is visible
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { draw(); }
      else { cancelAnimationFrame(raf); }
    }, { threshold: 0.1 });

    observer.observe(canvas.parentElement || canvas);
  }

  /* ----------------------------------------------------------
     SCROLL ANIMATIONS
  ---------------------------------------------------------- */
  function initScrollAnimations() {
    const elements = document.querySelectorAll('.ez-animate');
    if (!elements.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(el => observer.observe(el));
  }

  /* ----------------------------------------------------------
     FAQ ACCORDION
  ---------------------------------------------------------- */
  function initFAQ() {
    document.querySelectorAll('.ez-faq-question').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.ez-faq-item');
        const isOpen = item.classList.contains('open');

        // Close all
        document.querySelectorAll('.ez-faq-item.open').forEach(el => {
          el.classList.remove('open');
        });

        // Toggle current
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  /* ----------------------------------------------------------
     MARQUEE — pause on hover
  ---------------------------------------------------------- */
  function initMarquee() {
    const track = document.querySelector('.ez-marquee-track');
    if (!track) return;
    track.addEventListener('mouseenter', () => { track.style.animationPlayState = 'paused'; });
    track.addEventListener('mouseleave', () => { track.style.animationPlayState = 'running'; });
  }

  /* ----------------------------------------------------------
     TOAST NOTIFICATION
  ---------------------------------------------------------- */
  window.ezToast = function (message, duration = 3000) {
    let toast = document.querySelector('.ez-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ez-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.classList.remove('show'), duration);
  };

  /* ----------------------------------------------------------
     QUICK ADD TO CART
  ---------------------------------------------------------- */
  function initQuickAdd() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;

      const variantId = btn.dataset.quickAdd;
      if (!variantId) return;

      const original = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        if (!res.ok) throw new Error('Failed');

        window.ezToast('Added to cart!');
        updateCartCount();
      } catch {
        window.ezToast('Something went wrong. Try again.');
      } finally {
        btn.textContent = original;
        btn.disabled = false;
      }
    });
  }

  /* ----------------------------------------------------------
     CART COUNT BADGE
  ---------------------------------------------------------- */
  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const badge = document.querySelector('.ez-cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    } catch {}
  }

  /* ----------------------------------------------------------
     NEWSLETTER FORM
  ---------------------------------------------------------- */
  function initNewsletter() {
    document.querySelectorAll('.ez-newsletter-form').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const email = form.querySelector('input[type="email"]').value;
        if (!email) return;
        window.ezToast('Thanks for subscribing!');
        form.reset();
      });
    });
  }

  /* ----------------------------------------------------------
     PRODUCT IMAGE ZOOM (collection page)
  ---------------------------------------------------------- */
  function initImageHover() {
    document.querySelectorAll('.ez-product-image-wrap').forEach(wrap => {
      const img = wrap.querySelector('img');
      if (!img) return;

      wrap.addEventListener('mousemove', (e) => {
        const rect = wrap.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width - 0.5) * 6;
        const y = ((e.clientY - rect.top)  / rect.height - 0.5) * 6;
        img.style.transform = `scale(1.08) translate(${x}px, ${y}px)`;
      });
      wrap.addEventListener('mouseleave', () => {
        img.style.transform = '';
      });
    });
  }

  /* ----------------------------------------------------------
     SUPPORT SEARCH (visual filter only)
  ---------------------------------------------------------- */
  function initSupportSearch() {
    const input = document.querySelector('.ez-support-search input');
    if (!input) return;
    input.addEventListener('input', () => {
      const q = input.value.toLowerCase();
      document.querySelectorAll('.ez-faq-item').forEach(item => {
        const text = item.textContent.toLowerCase();
        item.style.display = text.includes(q) ? '' : 'none';
      });
    });
  }

  /* ----------------------------------------------------------
     INIT ALL
  ---------------------------------------------------------- */
  function init() {
    initHeader();
    initConfetti();
    initScrollAnimations();
    initFAQ();
    initMarquee();
    initQuickAdd();
    initNewsletter();
    initImageHover();
    initSupportSearch();
    updateCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
